var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { class: _vm.embedded ? "" : "ma-5", attrs: { flat: "" } },
    [
      _c(
        "v-card-text",
        { class: _vm.embedded ? "api-explorer-embedded-card" : "" },
        [
          _vm.loadingSpec
            ? _c(
                "div",
                { staticClass: "d-flex justify-center align-center py-8" },
                [
                  _c("v-progress-circular", {
                    attrs: { indeterminate: "", color: "primary" },
                  }),
                ],
                1
              )
            : _vm.specError
            ? _c(
                "v-alert",
                {
                  staticClass: "mb-0",
                  attrs: { type: "error", outlined: "", dense: "" },
                },
                [_vm._v(" " + _vm._s(_vm.$t("failed-to-load-api")) + " ")]
              )
            : _c("div", { staticClass: "api-explorer-content" }, [
                _c(
                  "div",
                  { staticClass: "token-section mb-4" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "token-header clickable",
                        on: {
                          click: function ($event) {
                            _vm.sections.token = !_vm.sections.token
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex align-center" },
                          [
                            _c(
                              "v-icon",
                              {
                                staticClass: "mr-2 collapse-icon",
                                class: { collapsed: !_vm.sections.token },
                                attrs: { color: "white", size: "18" },
                              },
                              [_vm._v("mdi-chevron-down")]
                            ),
                            _c(
                              "v-icon",
                              {
                                staticClass: "mr-2",
                                attrs: { color: "white", size: "20" },
                              },
                              [_vm._v("mdi-shield-key")]
                            ),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("authorization-token"))),
                            ]),
                            _c(
                              "v-chip",
                              {
                                staticClass: "ml-2",
                                attrs: {
                                  "x-small": "",
                                  color: _vm.hasToken ? "green" : "red",
                                  dark: "",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.hasToken
                                        ? _vm.$t("api-status-active")
                                        : _vm.$t("missing")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "d-flex align-center" },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "copy-token-btn",
                                attrs: {
                                  small: "",
                                  text: "",
                                  color: "white",
                                  disabled: !_vm.hasToken,
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.copyToken.apply(null, arguments)
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { small: "", left: "" } },
                                  [_vm._v("mdi-content-copy")]
                                ),
                                _vm._v(" " + _vm._s(_vm.$t("copy-jwt")) + " "),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c("v-expand-transition", [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.sections.token,
                              expression: "sections.token",
                            },
                          ],
                          staticClass: "token-preview",
                        },
                        [
                          _c("span", { staticClass: "token-value" }, [
                            _vm._v(_vm._s(_vm.tokenPreview)),
                          ]),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "endpoint-section mb-4" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "endpoint-header clickable",
                        on: {
                          click: function ($event) {
                            _vm.sections.endpoint = !_vm.sections.endpoint
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex align-center" },
                          [
                            _c(
                              "v-icon",
                              {
                                staticClass: "mr-2 collapse-icon",
                                class: { collapsed: !_vm.sections.endpoint },
                                attrs: { color: "white", size: "18" },
                              },
                              [_vm._v("mdi-chevron-down")]
                            ),
                            _c(
                              "v-icon",
                              {
                                staticClass: "mr-2",
                                attrs: { color: "white", size: "20" },
                              },
                              [_vm._v("mdi-api")]
                            ),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("api-endpoint"))),
                            ]),
                            _c(
                              "v-chip",
                              {
                                staticClass: "ml-2",
                                attrs: {
                                  "x-small": "",
                                  color: "white",
                                  "text-color": "grey darken-2",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.endpoints.length) +
                                    " routes "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c("v-expand-transition", [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.sections.endpoint,
                              expression: "sections.endpoint",
                            },
                          ],
                          staticClass: "endpoint-content",
                        },
                        [
                          _c("v-text-field", {
                            staticClass: "mb-3",
                            attrs: {
                              placeholder: _vm.$t("search-endpoints"),
                              "prepend-inner-icon": "mdi-magnify",
                              clearable: "",
                              "hide-details": "",
                              outlined: "",
                              dense: "",
                            },
                            model: {
                              value: _vm.searchQuery,
                              callback: function ($$v) {
                                _vm.searchQuery = $$v
                              },
                              expression: "searchQuery",
                            },
                          }),
                          _c(
                            "div",
                            { staticClass: "d-flex align-center mb-3" },
                            [
                              _c("v-switch", {
                                staticClass: "mt-0 pt-0",
                                attrs: {
                                  "hide-details": "",
                                  dense: "",
                                  color: "primary",
                                },
                                model: {
                                  value: _vm.manualMode,
                                  callback: function ($$v) {
                                    _vm.manualMode = $$v
                                  },
                                  expression: "manualMode",
                                },
                              }),
                              _c("span", { staticClass: "text-caption ml-2" }, [
                                _vm._v(_vm._s(_vm.$t("manual-mode"))),
                              ]),
                            ],
                            1
                          ),
                          _vm.manualMode
                            ? _c(
                                "div",
                                { staticClass: "manual-input mb-3" },
                                [
                                  _c(
                                    "v-row",
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "3" } },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              items: _vm.httpMethods,
                                              label: _vm.$t("method"),
                                              outlined: "",
                                              dense: "",
                                              "hide-details": "",
                                              "item-color": _vm.getMethodColor(
                                                _vm.selectedMethod
                                              ),
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "selection",
                                                  fn: function ({ item }) {
                                                    return [
                                                      _c(
                                                        "v-chip",
                                                        {
                                                          staticClass:
                                                            "method-chip",
                                                          attrs: {
                                                            "x-small": "",
                                                            color:
                                                              _vm.getMethodColor(
                                                                item
                                                              ),
                                                            dark: "",
                                                            label: "",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(item) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "item",
                                                  fn: function ({ item }) {
                                                    return [
                                                      _c(
                                                        "v-chip",
                                                        {
                                                          staticClass:
                                                            "method-chip",
                                                          attrs: {
                                                            "x-small": "",
                                                            color:
                                                              _vm.getMethodColor(
                                                                item
                                                              ),
                                                            dark: "",
                                                            label: "",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(item) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              481560956
                                            ),
                                            model: {
                                              value: _vm.selectedMethod,
                                              callback: function ($$v) {
                                                _vm.selectedMethod = $$v
                                              },
                                              expression: "selectedMethod",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "9" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: _vm.$t("path"),
                                              placeholder: "/api/endpoint",
                                              outlined: "",
                                              dense: "",
                                              "hide-details": "",
                                            },
                                            model: {
                                              value: _vm.manualPath,
                                              callback: function ($$v) {
                                                _vm.manualPath = $$v
                                              },
                                              expression: "manualPath",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                { staticClass: "endpoint-list" },
                                [
                                  _vm.groupedEndpoints.length
                                    ? _vm._l(
                                        _vm.groupedEndpoints,
                                        function (group) {
                                          return _c(
                                            "div",
                                            {
                                              key: group.tag,
                                              staticClass: "endpoint-group",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "endpoint-group-header",
                                                },
                                                [
                                                  _c("span", {
                                                    staticClass:
                                                      "group-tag-dot",
                                                    style: {
                                                      background: group
                                                        .endpoints[0]
                                                        ? _vm.getMethodColor(
                                                            group.endpoints[0]
                                                              .method
                                                          )
                                                        : "#999",
                                                    },
                                                  }),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "group-tag-name",
                                                    },
                                                    [_vm._v(_vm._s(group.tag))]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "endpoint-count",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          group.endpoints.length
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._l(
                                                group.endpoints,
                                                function (endpoint) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: endpoint.id,
                                                      staticClass:
                                                        "endpoint-item",
                                                      class: {
                                                        "endpoint-selected":
                                                          _vm.selectedEndpoint
                                                            ?.id ===
                                                          endpoint.id,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.selectEndpoint(
                                                            endpoint
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "endpoint-item-main",
                                                        },
                                                        [
                                                          _c(
                                                            "v-chip",
                                                            {
                                                              staticClass:
                                                                "method-chip",
                                                              attrs: {
                                                                "x-small": "",
                                                                color:
                                                                  _vm.getMethodColor(
                                                                    endpoint.method
                                                                  ),
                                                                dark: "",
                                                                label: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    endpoint.method
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "v-tooltip",
                                                            {
                                                              attrs: {
                                                                bottom: "",
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "activator",
                                                                      fn: function ({
                                                                        on,
                                                                        attrs,
                                                                      }) {
                                                                        return [
                                                                          _c(
                                                                            "v-icon",
                                                                            _vm._g(
                                                                              _vm._b(
                                                                                {
                                                                                  staticClass:
                                                                                    "security-icon",
                                                                                  attrs:
                                                                                    {
                                                                                      "x-small":
                                                                                        "",
                                                                                      color:
                                                                                        endpoint.isPublic
                                                                                          ? "green"
                                                                                          : "red",
                                                                                    },
                                                                                },
                                                                                "v-icon",
                                                                                attrs,
                                                                                false
                                                                              ),
                                                                              on
                                                                            ),
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    endpoint.isPublic
                                                                                      ? "mdi-earth"
                                                                                      : "mdi-lock"
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                  ],
                                                                  null,
                                                                  true
                                                                ),
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    endpoint.isPublic
                                                                      ? _vm.$t(
                                                                          "public"
                                                                        )
                                                                      : _vm.$t(
                                                                          "authorization-required"
                                                                        )
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _c("span", {
                                                            staticClass:
                                                              "endpoint-path",
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                _vm.breakablePath(
                                                                  endpoint.path
                                                                )
                                                              ),
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      endpoint.summary
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "endpoint-summary",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    endpoint.summary
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          )
                                        }
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "no-results" },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "grey" } },
                                            [_vm._v("mdi-magnify-close")]
                                          ),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("no-endpoints-found")
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                ],
                                2
                              ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
                _vm.selectedEndpoint || _vm.manualMode
                  ? _c(
                      "div",
                      {
                        ref: "requestSection",
                        staticClass: "request-section mb-4",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "request-header clickable",
                            on: {
                              click: function ($event) {
                                _vm.sections.request = !_vm.sections.request
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "d-flex align-center" },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-2 collapse-icon",
                                    class: { collapsed: !_vm.sections.request },
                                    attrs: { color: "white", size: "18" },
                                  },
                                  [_vm._v("mdi-chevron-down")]
                                ),
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-2",
                                    attrs: { color: "white", size: "20" },
                                  },
                                  [_vm._v("mdi-send")]
                                ),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("api-request"))),
                                ]),
                                _vm.selectedEndpoint
                                  ? _c(
                                      "v-chip",
                                      {
                                        staticClass: "ml-2",
                                        attrs: {
                                          "x-small": "",
                                          color: _vm.getMethodColor(
                                            _vm.selectedEndpoint.method
                                          ),
                                          dark: "",
                                          label: "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.selectedEndpoint.method
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass: "execute-btn",
                                attrs: {
                                  small: "",
                                  color: _vm.executing ? "grey" : "white",
                                  text: !_vm.executing,
                                  loading: _vm.executing,
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.executeRequest.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { small: "", left: "" } },
                                  [_vm._v("mdi-play")]
                                ),
                                _vm._v(" " + _vm._s(_vm.$t("execute")) + " "),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("v-expand-transition", [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.sections.request,
                                  expression: "sections.request",
                                },
                              ],
                              staticClass: "request-content",
                            },
                            [
                              _c("div", { staticClass: "request-path mb-3" }, [
                                _c("span", { staticClass: "path-label" }, [
                                  _vm._v("URL:"),
                                ]),
                                _c("code", { staticClass: "path-value" }, [
                                  _vm._v(
                                    " " + _vm._s(_vm.fullRequestUrl) + " "
                                  ),
                                ]),
                              ]),
                              _vm.pathParams.length
                                ? _c(
                                    "div",
                                    { staticClass: "params-section mb-3" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "params-label" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("path-parameters")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _vm._l(_vm.pathParams, function (param) {
                                        return _c(
                                          "div",
                                          {
                                            key: param.name,
                                            staticClass: "param-row",
                                          },
                                          [
                                            _c("v-text-field", {
                                              staticClass: "param-input",
                                              attrs: {
                                                label: param.name,
                                                placeholder:
                                                  param.description ||
                                                  param.name,
                                                hint: param.schema?.type,
                                                "persistent-hint": "",
                                                outlined: "",
                                                dense: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.paramValues[param.name],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.paramValues,
                                                    param.name,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "paramValues[param.name]",
                                              },
                                            }),
                                            param.required
                                              ? _c(
                                                  "v-chip",
                                                  {
                                                    staticClass: "ml-2",
                                                    attrs: {
                                                      "x-small": "",
                                                      color: "red",
                                                      dark: "",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t("api-required")
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      }),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm.queryParams.length
                                ? _c(
                                    "div",
                                    { staticClass: "params-section mb-3" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "params-label" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("query-parameters")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _vm._l(_vm.queryParams, function (param) {
                                        return _c(
                                          "div",
                                          {
                                            key: param.name,
                                            staticClass: "param-row",
                                          },
                                          [
                                            _c("v-text-field", {
                                              staticClass: "param-input",
                                              attrs: {
                                                label: param.name,
                                                placeholder:
                                                  param.description ||
                                                  param.name,
                                                hint: param.schema?.type,
                                                "persistent-hint": "",
                                                outlined: "",
                                                dense: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.paramValues[param.name],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.paramValues,
                                                    param.name,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "paramValues[param.name]",
                                              },
                                            }),
                                            param.required
                                              ? _c(
                                                  "v-chip",
                                                  {
                                                    staticClass: "ml-2",
                                                    attrs: {
                                                      "x-small": "",
                                                      color: "red",
                                                      dark: "",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t("api-required")
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      }),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "params-section mb-3" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "params-label d-flex align-center justify-space-between",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("custom-query-parameters")
                                          )
                                        ),
                                      ]),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            "x-small": "",
                                            text: "",
                                            color: "primary",
                                          },
                                          on: {
                                            click: _vm.addCustomQueryParam,
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                "x-small": "",
                                                left: "",
                                              },
                                            },
                                            [_vm._v("mdi-plus")]
                                          ),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("add-parameter")) +
                                              " "
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._l(
                                    _vm.customQueryParams,
                                    function (param, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass:
                                            "param-row custom-param-row",
                                        },
                                        [
                                          _c("v-text-field", {
                                            staticClass:
                                              "param-name-input mr-2",
                                            attrs: {
                                              placeholder:
                                                _vm.$t("parameter-name"),
                                              outlined: "",
                                              dense: "",
                                              "hide-details": "",
                                            },
                                            model: {
                                              value: param.name,
                                              callback: function ($$v) {
                                                _vm.$set(param, "name", $$v)
                                              },
                                              expression: "param.name",
                                            },
                                          }),
                                          _c("v-text-field", {
                                            staticClass: "param-value-input",
                                            attrs: {
                                              placeholder:
                                                _vm.$t("parameter-value"),
                                              outlined: "",
                                              dense: "",
                                              "hide-details": "",
                                            },
                                            model: {
                                              value: param.value,
                                              callback: function ($$v) {
                                                _vm.$set(param, "value", $$v)
                                              },
                                              expression: "param.value",
                                            },
                                          }),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "ml-2",
                                              attrs: {
                                                icon: "",
                                                "x-small": "",
                                                color: "red",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeCustomQueryParam(
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { "x-small": "" } },
                                                [_vm._v("mdi-close")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  !_vm.customQueryParams.length
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-caption grey--text mt-2",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("no-custom-parameters")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                2
                              ),
                              _vm.hasRequestBody
                                ? _c(
                                    "div",
                                    { staticClass: "params-section mb-3" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "params-label" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("request-body")) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _vm.requestBodyHints &&
                                      _vm.requestBodyHints.length > 0
                                        ? _c(
                                            "v-card",
                                            {
                                              staticClass:
                                                "mb-2 body-hints-card",
                                              attrs: {
                                                flat: "",
                                                outlined: "",
                                                dense: "",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-card-text",
                                                { staticClass: "pa-3" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "body-hints-title text-caption font-weight-bold mb-2 d-flex align-center",
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          staticClass: "mr-1",
                                                          attrs: {
                                                            "x-small": "",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-information-outline"
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "required-fields",
                                                              {
                                                                count:
                                                                  _vm.requestBodyHints.filter(
                                                                    (h) =>
                                                                      h.required
                                                                  ).length,
                                                              }
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "body-hints-list",
                                                    },
                                                    _vm._l(
                                                      _vm.requestBodyHints,
                                                      function (hint) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: hint.name,
                                                            staticClass:
                                                              "body-hint-item text-caption mb-1",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-flex align-center",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "font-weight-bold",
                                                                    style: {
                                                                      color:
                                                                        hint.required
                                                                          ? "#d32f2f"
                                                                          : "#666",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          hint.name
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                    hint.required
                                                                      ? _c(
                                                                          "v-chip",
                                                                          {
                                                                            staticClass:
                                                                              "ml-1",
                                                                            attrs:
                                                                              {
                                                                                "x-small":
                                                                                  "",
                                                                                color:
                                                                                  "error",
                                                                                "text-color":
                                                                                  "white",
                                                                                label:
                                                                                  "",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " " +
                                                                                _vm._s(
                                                                                  _vm.$t(
                                                                                    "required"
                                                                                  )
                                                                                ) +
                                                                                " "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "ml-2 grey--text text--darken-1",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          hint.type
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            hint.description
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "grey--text text-caption ml-4 mt-1",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          hint.description
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c("v-textarea", {
                                        staticClass: "body-input",
                                        class: {
                                          "json-invalid": _vm.bodyError,
                                        },
                                        attrs: {
                                          placeholder: '{"key": "value"}',
                                          outlined: "",
                                          dense: "",
                                          rows: "4",
                                          "error-messages": _vm.bodyError,
                                        },
                                        on: {
                                          input: _vm.validateJson,
                                          paste: _vm.onPaste,
                                        },
                                        model: {
                                          value: _vm.requestBody,
                                          callback: function ($$v) {
                                            _vm.requestBody = $$v
                                          },
                                          expression: "requestBody",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.hasResponse
                  ? _c(
                      "div",
                      {
                        ref: "responseSection",
                        staticClass: "response-section",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "response-header clickable",
                            class: _vm.responseHeaderClass,
                            on: {
                              click: function ($event) {
                                _vm.sections.response = !_vm.sections.response
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "d-flex align-center" },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-2 collapse-icon",
                                    class: {
                                      collapsed: !_vm.sections.response,
                                    },
                                    attrs: { color: "white", size: "18" },
                                  },
                                  [_vm._v("mdi-chevron-down")]
                                ),
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-2",
                                    attrs: { color: "white", size: "20" },
                                  },
                                  [_vm._v("mdi-code-json")]
                                ),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("response"))),
                                ]),
                                _vm.responseStatus
                                  ? _c(
                                      "v-chip",
                                      {
                                        staticClass: "ml-2",
                                        attrs: {
                                          "x-small": "",
                                          color: _vm.responseStatusColor,
                                          dark: "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.responseStatus) + " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "response-header-actions d-flex align-center",
                              },
                              [
                                _vm.responseTime
                                  ? _c(
                                      "span",
                                      { staticClass: "response-time ml-2" },
                                      [_vm._v(_vm._s(_vm.responseTime) + "ms")]
                                    )
                                  : _vm._e(),
                                _vm.responseSize !== null
                                  ? _c(
                                      "span",
                                      { staticClass: "response-size ml-2" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatBytes(_vm.responseSize)
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.responseHeaders
                                  ? _c(
                                      "v-btn",
                                      {
                                        staticClass: "headers-toggle-btn mr-1",
                                        class: {
                                          "headers-active": _vm.showHeaders,
                                        },
                                        attrs: {
                                          small: "",
                                          text: "",
                                          color: "white",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            _vm.showHeaders = !_vm.showHeaders
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { small: "", left: "" } },
                                          [_vm._v("mdi-swap-vertical")]
                                        ),
                                        _vm._v(
                                          " " + _vm._s(_vm.$t("headers")) + " "
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "headers-count" },
                                          [
                                            _vm._v(
                                              "(" +
                                                _vm._s(
                                                  Object.keys(
                                                    _vm.responseHeaders
                                                  ).length
                                                ) +
                                                ")"
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "copy-response-btn",
                                    attrs: {
                                      small: "",
                                      text: "",
                                      color: "white",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.copyResponse.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { small: "", left: "" } },
                                      [_vm._v("mdi-content-copy")]
                                    ),
                                    _vm._v(" " + _vm._s(_vm.$t("copy")) + " "),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c("v-expand-transition", [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.sections.response,
                                  expression: "sections.response",
                                },
                              ],
                              staticClass: "response-content",
                            },
                            [
                              _c("v-expand-transition", [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.showHeaders &&
                                          _vm.responseHeaders,
                                        expression:
                                          "showHeaders && responseHeaders",
                                      },
                                    ],
                                    staticClass: "response-headers-panel",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "headers-panel-header" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "headers-panel-title",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("response-headers"))
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: {
                                              bottom: "",
                                              "max-width": "300",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "v-icon",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              staticClass:
                                                                "ml-2",
                                                              attrs: {
                                                                "x-small": "",
                                                                color:
                                                                  "grey lighten-1",
                                                              },
                                                            },
                                                            "v-icon",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _vm._v(
                                                            " mdi-information-outline "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              3381034314
                                            ),
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("headers-cors-info")
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "headers-grid" },
                                      [
                                        _vm._l(
                                          _vm.responseHeaders,
                                          function (value, key) {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  key: key + "-name",
                                                  staticClass: "header-name",
                                                },
                                                [_vm._v(_vm._s(key))]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  key: key + "-value",
                                                  staticClass: "header-value",
                                                },
                                                [_vm._v(_vm._s(value))]
                                              ),
                                            ]
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                              ]),
                              _vm.responseStatus && !_vm.responseError
                                ? _c("pre", { staticClass: "response-body" }, [
                                    _vm._v(_vm._s(_vm.formattedResponse)),
                                  ])
                                : _vm.responseError
                                ? _c("div", { staticClass: "response-error" }, [
                                    _vm._v(
                                      " " + _vm._s(_vm.responseError) + " "
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }